"use strict";

export { default as iconset } from "./components/iconset.js";
export { default as NsIcon } from "./components/NsIcon.vue";
